import PropTypes from 'prop-types'

const propTypes = {
  label : PropTypes.string,
  rules : PropTypes.array
}

const RuleDescriptions = ({ label, rules }) => {
  const doesRuleExist = rules?.length >0
  return (
    <>
      { doesRuleExist && (
        <div className='px-3 pt-3'>
          <span className='font-weight-bolder text-capitalize'>{ label }</span>
          <ul className='px-4'>
            {
              rules?.map((description) => (
                <li key={ description[ 'code' ] }>{ description[ 'description' ].join('<br/>') }</li>
              ))
            }
          </ul>
        </div>
      )

      }
    </>
  )
}

RuleDescriptions.propTypes = propTypes
export default RuleDescriptions